import React from 'react';
import moment from 'moment';
import ToolTip, {tooltipPositions} from 'components/ToolTip';
import {dateTimeFormats, scheduleReportExportURL} from 'helpers/constants';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import PropTypes from 'prop-types';
import SummarySectionPOSDate from '../../components/summarySectionPosDate';
import ReportSummaryErrorHandler from '../../components/reportSummaryErrorHandler';

class OutboundEmailsSummary extends React.Component {
  static propTypes = {
    intl: intlShape,
    dealer: PropTypes.any.isRequired,
    POSActive: PropTypes.bool,
    dateFrom: PropTypes.any,
    dateTo: PropTypes.any,
    data: PropTypes.any,
    latestReport: PropTypes.any,
  };


  getDateRange = () => {
    const {formatMessage} = this.props.intl;

    let dateFrom = moment(this.props.dateFrom).format(dateTimeFormats.numeralDate);
    let dateTo = moment(this.props.dateTo).format(dateTimeFormats.numeralDate);

    return formatMessage({id: 'general.date.range'}, {
      start: dateFrom,
      end: dateTo,
    });
  };

  getSubTypes = subTypes => {
    return <div>
      {subTypes.map(i => {
        const subTypeCopyKey = `report.outbound.emailsubtype.${i.toLowerCase()}`;

        return <h6 key={i}><FormattedMessage id={subTypeCopyKey}/></h6>;
      }
      )}
    </div>;
  };

  export = (URL) => {
    window.open(URL, '_parent');
  }

  render() {
    const {data, latestReport} = this.props;
    const {locale} = this.props.intl;
    const exportURLKey = locale === 'fr-CA' ? scheduleReportExportURL.XLSX_FR : scheduleReportExportURL.XLSX;
    let tableRows;

    const dateRange = <FormattedMessage id='general.date.range.labelled' values={{
      start: moment(this.props.dateFrom).format(dateTimeFormats.numeralDate),
      end: moment(this.props.dateTo).format(dateTimeFormats.numeralDate),
    }}/>;

    if(data && Object.keys(data).length) {
      tableRows = data.map((row, i) =>{
        const emailTypeCopyKey = `report.outbound.emailtype.${row.EmailType.toLowerCase()}`;

        return <tr key={i} className={i % 2 !== 0 ? 'gray-row' : ''}>
          <td className={row.SubTypes.length > 0 ? 'icon-column' : 'hidden-icon'}>
            <ToolTip title={this.getSubTypes(row.SubTypes)}
                        position={tooltipPositions.topLeft} iconClass={'bl bl-add'} iconOnly disabled={row.SubTypes.length <= 0}/>
          </td>
          <td><FormattedMessage id={emailTypeCopyKey}/></td>
          <td className="table-number">{row.SentCount}</td>
        </tr>;
      }
			);
    }

    return <ReportSummaryErrorHandler>
      <div>
        <div className="summary-container">
          <h2><FormattedMessage id="reports.report.summary"/></h2>
          <span className={Object.keys(data).length && this.props.dateFrom && this.props.dateTo ? 'summary-date' : 'not-show'}> | {dateRange}
          </span>
          <br/>
          <SummarySectionPOSDate POSActive={this.props.POSActive} dealer={this.props.dealer} />
          {!this.props.latestReport ?
            <label className="report-no-data"><FormattedMessage id="reports.error.no.results"/></label> :
            <div className="container-fluid custom-container-margins">
              <div className={data && Object.keys(data).length ? 'row' : 'not-show'}
               id="row-no-padding">
                <table className="summary-table">
                  <tbody>
                    <tr className="table-title">
                      <th style={{width: '65px'}}/>
                      <th><FormattedMessage id="general.email.type"/></th>
                      <th className="table-number"><FormattedMessage id="general.sent"/></th>
                    </tr>
                    {tableRows}
                  </tbody>
                </table>
              </div>
            </div> }
        </div>
        <div className='col-sm-12 button-group'>
          {!!latestReport && !!latestReport[exportURLKey] ? <button className='btn btn-primary pull-right'
                onClick={() => this.export(latestReport[exportURLKey])}><FormattedMessage id="general.download.latest"/></button> : null}
        </div>
      </div>
    </ReportSummaryErrorHandler>;
  }
}

export default injectIntl(OutboundEmailsSummary);
